module.exports = __webpack_public_path__ + "img/1.9ef3c0d3.png";